module.exports = "<cian-af-helper-floor ad=\"floor.ad\" form=\"floor.form\" min-floor=\"floor.minFloorNumber\"></cian-af-helper-floor>"